import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { transacoesCliente } from 'service/api'
import { useStore } from 'store'
import { TransacaoButton } from './TransacoesButton'

export const columnsTransacoes: GridColDefPro[] = [
    {
        field: 'subscriptionMyId',
        headerName: 'Contrato',
        width: 85,
        renderCell: ({ value }) => (
            <span title={value}>{value?.split('-')?.at(0)}</span>
        ),
    },
    {
        field: 'galaxPayId',
        headerName: 'Código',
        width: 70,
    },
    {
        field: 'CreditCard',
        headerName: 'Método de pagamento',
        width: 200,
        valueGetter: params => {
            if (params.row.CreditCard) {
                const bandeiraCartao =
                    params.row.CreditCard.Card?.Brand?.name ?? ''
                const ultimosNumeros =
                    params.row.CreditCard.Card?.number.slice(-4) ?? ''

                return `${bandeiraCartao} **** **** ${ultimosNumeros}`
            }
            if (params.row.Boleto) return 'Boleto'
            return 'PIX'
        },
    },
    {
        field: 'payday',
        headerName: 'Vencimento',
        width: 110,
        valueFormatter: params => {
            return dayjs(params.value).format('DD/MM/YYYY')
        },
    },
    {
        field: 'value',
        headerName: 'Valor',
        width: 110,
        valueFormatter: params => {
            const value = (params.value as number) / 100

            return value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            })
        },
    },
    {
        field: 'statusDescription',
        headerName: 'Status',
        minWidth: 200,
        flex: 0.8,
    },
    {
        field: 'createdAt',
        headerName: 'Gerado em',
        width: 160,
        valueFormatter: params =>
            dayjs(params.value as string).format('DD/MM/YYYY HH:mm:ss'),
    },
    {
        field: 'additionalInfo',
        headerName: 'Informações adicionais',
        minWidth: 250,
        flex: 1,
    },
    {
        ...optionsColumn,
        field: '__opcoes',
        renderCell: TransacaoButton,
    },
]

export default function DataGridTransacoes() {
    const cliente = useStore(state => state.customer)

    const { data: transacoes, isLoading } = transacoesCliente.useFetch({
        queryParams: { clienteId: cliente?.id },
        enabled: !!cliente?.id,
    })

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={1}
            flex={1}
            minHeight="14rem"
            width="100%"
        >
            <Typography
                variant="h6"
                color={theme => theme.palette.grey[600]}
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    userSelect: 'none',
                }}
            >
                Histórico de pagamentos
            </Typography>
            <ContentGuide.DataGrid
                loading={isLoading}
                columns={columnsTransacoes}
                rows={transacoes?.map((t, id) => ({
                    id,
                    ...t,
                }))}
                hideFooter
                ToolbarProps={{ hideToolbar: true }}
                headerHeight={40}
                rowHeight={40}
            />
        </Box>
    )
}
